<div *ngIf="showTablePrincipal">
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Rutas y viajes asociados</h2>

    <div class="radio-wrapper">
        <mat-radio-group [value]="typeModal" (change)="onTypeModalChange($event.value)" class="radio-group-inline">
            <mat-radio-button value="vehicle">Vehículo</mat-radio-button>
            <mat-radio-button value="businessPartner">Socio de Negocios</mat-radio-button>
        </mat-radio-group>
    </div>

    <mat-dialog-content>
        <div *ngIf="typeModal === 'vehicle'">
            <app-vehicles-filters *ngIf="search" [form]="form" [vehicle]="true"></app-vehicles-filters>

            <div class="overflow-y-auto max-h-96">
                <table class="w-full bg-transparent" mat-table [dataSource]="dataSourceVehicle" matSort
                    matSortDisableClear multiTemplateDataRows>

                    <!-- Nombre -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Nombre</th>
                        <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                            <b class="text-[10px]">{{element.code}}</b><br>
                            {{ element.name }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="businessPartner">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Socio de Negocio -
                            Propietario</th>
                        <td mat-cell *matCellDef="let element" class="leading-tight text-sm">
                            <div *ngIf="getCode(element?.businessPartner) as code">
                                <b class="text-[10px]">{{ code }}</b>
                            </div>
                            <span> {{element?.businessPartner?.name}}</span>
                        </td>
                    </ng-container>

                    <!-- Tipo -->
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Tipo</th>
                        <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                            <b class="text-[10px]">{{element.type?.code}}</b><br>
                            {{ element.type?.name }}
                        </td>
                    </ng-container>

                    <!-- Placa -->
                    <ng-container matColumnDef="plate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Placa</th>
                        <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                            {{ element.plate }}</td>
                    </ng-container>

                    <!-- Acciones -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                        <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                            <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #actionMenu="matMenu">
                                <button mat-menu-item (click)="openRoutesModal(element.subRoutes)">
                                    <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                                    <span>Rutas</span>
                                </button>
                                <button mat-menu-item (click)="openTripsModal(element.currentTrips)">
                                    <mat-icon svgIcon="heroicons_outline:map"></mat-icon>
                                    <span>Viajes</span>
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <!-- Header Row -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"
                        class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

                    <!-- Fila principal -->
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
                </table>
            </div>
        </div>
        <div *ngIf="typeModal === 'businessPartner'">

            <app-business-partners-filters *ngIf="search" [form]="form"
                [assignedUserWithMongoId]="true"></app-business-partners-filters>
            <div class="overflow-y-auto max-h-96">
                <table class="w-full bg-transparent" mat-table [dataSource]="dataSourceCustomer" matSort
                    matSortDisableClear multiTemplateDataRows>

                    <!-- Nombre -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Nombre</th>
                        <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                            <b class="text-[10px]">{{element.externalKeys?.code}}</b><br>
                            {{ element.name }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Tipo</th>
                        <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                            {{element?.types?.[0].name}}
                        </td>
                    </ng-container>

                    <!-- Acciones -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                        <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                            <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #actionMenu="matMenu">
                                <button mat-menu-item
                                    (click)="openRoutesModal(element.subRoutes, element.name, element?.externalKeys?.code)">
                                    <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                                    <span>Rutas</span>
                                </button>
                                <button mat-menu-item
                                    (click)="openTripsModal(element.currentTrips, element.name, element?.externalKeys?.code)">
                                    <mat-icon svgIcon="heroicons_outline:map"></mat-icon>
                                    <span>Viajes</span>
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <!-- Header Row -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBusinessPartner"
                        class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

                    <!-- Fila principal -->
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBusinessPartner;" class="border-b"></tr>
                </table>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close>Salir</button>
    </mat-dialog-actions>

    <ng-template #routesModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Rutas</h2>
        <mat-dialog-content class="modal-content">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSourceRoutes" matSort matSortDisableClear
                multiTemplateDataRows>

                <ng-container matColumnDef="route">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Ruta</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                        <div>
                            <b class="text-[10px]">{{ element.subRouteCode }}</b>
                        </div>
                        {{ element.nameSubRoute }}
                    </td>
                </ng-container>

                <!-- Territorios Column -->
                <ng-container matColumnDef="territory">
                    <th mat-header-cell *matHeaderCellDef class="font-semibold">Territorios</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="text-sm">
                            <div *ngIf="getTerritoriesRoutes(element).length > 0; else noTerritories">
                                <div class="flex flex-wrap gap-1">
                                    <span *ngFor="let territory of getTerritoriesRoutes(element)"
                                        class="inline-flex items-center px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800">
                                        <mat-icon class="!w-3 !h-3 !text-[12px] mr-1">location_on</mat-icon>
                                        {{ territory.externalKeys?.code ? (territory.externalKeys.code + ' - ' +
                                        territory.name) : territory.name }}
                                    </span>
                                </div>
                            </div>
                            <ng-template #noTerritories>
                                <span class="text-gray-400">Sin territorios</span>
                            </ng-template>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="saleOffice">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Oficina de venta</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                        <div>
                            <b class="text-[10px]">{{ element.salesOfficeCode }}</b>
                        </div>
                        {{ element.salesOffice }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="assignedUser">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Usuario asignado</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                        <div>
                            <b class="text-[10px]">{{ element.assignedUserCode }}</b>
                        </div>
                        {{ element.assignedUser }}
                    </td>
                </ng-container>

                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumnsRoutes"
                    class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

                <!-- Fila principal -->
                <tr mat-row *matRowDef="let row; columns: displayedColumnsRoutes;" class="border-b"></tr>
            </table>
        </mat-dialog-content>

        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close>Salir</button>
        </mat-dialog-actions>
    </ng-template>

    <ng-template #tripsModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Viajes</h2>
        <mat-dialog-content class="modal-content">
            <table class="w-full bg-transparent table-trips" mat-table [dataSource]="dataSourceTrips" matSort
                matSortDisableClear multiTemplateDataRows>

                <!-- Nombre -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left" style="min-width: 50px;">
                        Viaje</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase"
                        style="min-width: 50px;">
                        <div class="flex items-center px-3 cursor-pointer" [ngClass]="{ 'underline': hasTrip(element) }"
                            (click)="hasTrip(element) && goToTravel(element)"
                            [matTooltip]="hasTrip(element) ? 'Ir al viaje' : ''">
                            <span>{{ hasTrip(element) ? element.id : '-' }}</span>
                            <mat-icon *ngIf="hasTrip(element)" class="ml-2 icon-size-3 hover:animate-bounce"
                                [svgIcon]="'heroicons_outline:rocket-launch'" style="color:rgb(0, 0, 0);"></mat-icon>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="trip">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">
                        Viaje
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-secondary text-left first-col table-text">
                        <div class="flex items-center px-3 cursor-pointer" [ngClass]="{ 'underline': hasTrip(element) }"
                            (click)="hasTrip(element) && goToTravel(element)"
                            [matTooltip]="hasTrip(element) ? 'Ir al viaje' : ''">
                            <span>{{ hasTrip(element) ? element.trip.id : '-' }}</span>
                            <mat-icon *ngIf="hasTrip(element)" class="ml-2 icon-size-3 hover:animate-bounce"
                                [svgIcon]="'heroicons_outline:rocket-launch'" style="color:rgb(0, 0, 0);"></mat-icon>
                        </div>
                    </td>
                </ng-container>

                <!-- Route -->
                <ng-container matColumnDef="subRoute">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left"
                        style="padding-right: 10px;">Ruta</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase"
                        style="padding-right: 10px;">
                        <div>
                            <b class="text-[10px]">{{ element.subRouteCode }}</b>
                        </div>
                        {{ element.nameSubRoute }}
                    </td>
                </ng-container>

                <!-- Territorios Column -->
                <ng-container matColumnDef="territory">
                    <th mat-header-cell *matHeaderCellDef class="font-semibold" style="min-width: 90px;">Territorios
                    </th>
                    <td mat-cell *matCellDef="let element" style="min-width: 90px;">
                        <div class="text-sm">
                            <div *ngIf="getTerritoriesTrips(element).length > 0; else noTerritories">
                                <div class="flex flex-wrap gap-1">
                                    <span *ngFor="let territory of getTerritoriesTrips(element)"
                                        class="inline-flex items-center px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800">
                                        <mat-icon class="!w-3 !h-3 !text-[12px] mr-1">location_on</mat-icon>
                                        {{ territory.externalKeys?.code ? (territory.externalKeys.code + ' - ' +
                                        territory.name) : territory.name }}
                                    </span>
                                </div>
                            </div>
                            <ng-template #noTerritories>
                                <span class="text-gray-400">Sin territorios</span>
                            </ng-template>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="function">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left" style="min-width: 80px;">
                        Función</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase"
                        style="min-width: 80px;">
                        <div>
                            <b class="text-[10px]">{{ element.functionCode }}</b>
                        </div>
                        {{ element.function }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left" style="min-width: 130px;">
                        Fecha Teórica</th>
                    <td mat-cell *matCellDef="let element" class=" text-left" style="min-width: 130px;">
                        <p class="table-text-m" style="min-width: 102px;">
                            <span class="f-10">
                                FI:{{element?.dateHourStartTeoric | FormatDateHour: false }}<br>
                                FF:{{element?.dateHourEndTeoric | FormatDateHour: false }}<br>
                            </span>
                        </p>
                    </td>
                </ng-container>


                <ng-container matColumnDef="user">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Usuario asignado</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                        <div>
                            <b class="text-[10px]">{{ element.assignedUserCode }}</b>
                        </div>
                        {{ element.assignedUser }}
                    </td>
                </ng-container>

                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumnsTrips"
                    class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

                <!-- Fila principal -->
                <tr mat-row *matRowDef="let row; columns: displayedColumnsTrips;" class="border-b"></tr>
            </table>
        </mat-dialog-content>

        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close>Salir</button>
        </mat-dialog-actions>
    </ng-template>
</div>

<div *ngIf="!showTablePrincipal">
    <div *ngIf="showTrips">
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Viajes</h2>
        <mat-dialog-content class="modal-content">
            <table class="w-full bg-transparent table-trips" mat-table [dataSource]="dataSourceTrips" matSort
                matSortDisableClear multiTemplateDataRows>

                <!-- Nombre -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left" style="min-width: 50px;">
                        Viaje</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase"
                        style="min-width: 50px;">
                        <div class="flex items-center px-3 cursor-pointer" [ngClass]="{ 'underline': hasTrip(element) }"
                            (click)="hasTrip(element) && goToTravel(element)"
                            [matTooltip]="hasTrip(element) ? 'Ir al viaje' : ''">
                            <span>{{ hasTrip(element) ? element.id : '-' }}</span>
                            <mat-icon *ngIf="hasTrip(element)" class="ml-2 icon-size-3 hover:animate-bounce"
                                [svgIcon]="'heroicons_outline:rocket-launch'" style="color:rgb(0, 0, 0);"></mat-icon>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="trip">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">
                        Viaje
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-secondary text-left first-col table-text">
                        <div class="flex items-center px-3 cursor-pointer" [ngClass]="{ 'underline': hasTrip(element) }"
                            (click)="hasTrip(element) && goToTravel(element)"
                            [matTooltip]="hasTrip(element) ? 'Ir al viaje' : ''">
                            <span>{{ hasTrip(element) ? element.trip.id : '-' }}</span>
                            <mat-icon *ngIf="hasTrip(element)" class="ml-2 icon-size-3 hover:animate-bounce"
                                [svgIcon]="'heroicons_outline:rocket-launch'" style="color:rgb(0, 0, 0);"></mat-icon>
                        </div>
                    </td>
                </ng-container>

                <!-- Route -->
                <ng-container matColumnDef="subRoute">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left"
                        style="padding-right: 10px;">Ruta</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase"
                        style="padding-right: 10px;">
                        <div>
                            <b class="text-[10px]">{{ element.subRouteCode }}</b>
                        </div>
                        {{ element.nameSubRoute }}
                    </td>
                </ng-container>

                <!-- Territorios Column -->
                <ng-container matColumnDef="territory">
                    <th mat-header-cell *matHeaderCellDef class="font-semibold" style="min-width: 90px;">Territorios
                    </th>
                    <td mat-cell *matCellDef="let element" style="min-width: 90px;">
                        <div class="text-sm">
                            <div *ngIf="getTerritoriesTrips(element).length > 0; else noTerritories">
                                <div class="flex flex-wrap gap-1">
                                    <span *ngFor="let territory of getTerritoriesTrips(element)"
                                        class="inline-flex items-center px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800">
                                        <mat-icon class="!w-3 !h-3 !text-[12px] mr-1">location_on</mat-icon>
                                        {{ territory.externalKeys?.code ? (territory.externalKeys.code + ' - ' +
                                        territory.name) : territory.name }}
                                    </span>
                                </div>
                            </div>
                            <ng-template #noTerritories>
                                <span class="text-gray-400">Sin territorios</span>
                            </ng-template>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="function">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left" style="min-width: 80px;">
                        Función</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase"
                        style="min-width: 80px;">
                        <div>
                            <b class="text-[10px]">{{ element.functionCode }}</b>
                        </div>
                        {{ element.function }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left" style="min-width: 130px;">
                        Fecha Teórica</th>
                    <td mat-cell *matCellDef="let element" class=" text-left" style="min-width: 130px;">
                        <p class="table-text-m" style="min-width: 102px;">
                            <span class="f-10">
                                FI:{{element?.dateHourStartTeoric | FormatDateHour: false }}<br>
                                FF:{{element?.dateHourEndTeoric | FormatDateHour: false }}<br>
                            </span>
                        </p>
                    </td>
                </ng-container>


                <ng-container matColumnDef="user">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Usuario asignado</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                        <div>
                            <b class="text-[10px]">{{ element.assignedUserCode }}</b>
                        </div>
                        {{ element.assignedUser }}
                    </td>
                </ng-container>

                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumnsTrips"
                    class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

                <!-- Fila principal -->
                <tr mat-row *matRowDef="let row; columns: displayedColumnsTrips;" class="border-b"></tr>
            </table>
        </mat-dialog-content>

        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close>Salir</button>
        </mat-dialog-actions>
    </div>
    <div *ngIf="showSubRoutes">
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Rutas</h2>
        <mat-dialog-content class="modal-content">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSourceRoutes" matSort matSortDisableClear
                multiTemplateDataRows>

                <ng-container matColumnDef="route">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Ruta</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                        <div>
                            <b class="text-[10px]">{{ element.subRouteCode }}</b>
                        </div>
                        {{ element.nameSubRoute }}
                    </td>
                </ng-container>

                <!-- Territorios Column -->
                <ng-container matColumnDef="territory">
                    <th mat-header-cell *matHeaderCellDef class="font-semibold">Territorios</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="text-sm">
                            <div *ngIf="getTerritoriesRoutes(element).length > 0; else noTerritories">
                                <div class="flex flex-wrap gap-1">
                                    <span *ngFor="let territory of getTerritoriesRoutes(element)"
                                        class="inline-flex items-center px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800">
                                        <mat-icon class="!w-3 !h-3 !text-[12px] mr-1">location_on</mat-icon>
                                        {{ territory.externalKeys?.code ? (territory.externalKeys.code + ' - ' +
                                        territory.name) : territory.name }}
                                    </span>
                                </div>
                            </div>
                            <ng-template #noTerritories>
                                <span class="text-gray-400">Sin territorios</span>
                            </ng-template>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="saleOffice">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Oficina de venta</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                        <div>
                            <b class="text-[10px]">{{ element.salesOfficeCode }}</b>
                        </div>
                        {{ element.salesOffice }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="assignedUser">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Usuario asignado</th>
                    <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                        <div>
                            <b class="text-[10px]">{{ element.assignedUserCode }}</b>
                        </div>
                        {{ element.assignedUser }}
                    </td>
                </ng-container>

                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumnsRoutes"
                    class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

                <!-- Fila principal -->
                <tr mat-row *matRowDef="let row; columns: displayedColumnsRoutes;" class="border-b"></tr>
            </table>
        </mat-dialog-content>

        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close>Salir</button>
        </mat-dialog-actions>
    </div>
</div>